import React from 'react';
import { connect } from 'react-redux';
import { MAGIC_NUMBER } from '../../constants/magicNumbers';
import { PlusMinusQuantity } from '../roomsQuantity/component';

import { updateFilters } from '../search/actions';

const mapStateToProps = state => ({
  search: state.Search
});
class GuestsQuantity extends React.Component {
  constructor(props) {
    super(props);

    this.onChange = this.onChange.bind(this);
    this.getValue = this.getValue.bind(this);
  }

  onChange(increment) {
    const { dispatch } = this.props;

    const { filters } = this.props.search;

    const newFilters = { ...filters };

    let guestsQuantity = filters.guests + increment;

    guestsQuantity = Math.min(guestsQuantity, MAGIC_NUMBER.MAX_GUESTS);
    guestsQuantity = Math.max(guestsQuantity, 0);
    newFilters.guests = guestsQuantity;

    dispatch(updateFilters(newFilters));
  }

  getValue = () => {
    const { guests } = this.props.search.filters;
    const { showMessageOnNone, showLabel } = this.props;

    if (guests <= 0 && !!showMessageOnNone) {
      return "No. of Guests";
    } else {
      let label = ` Guest${guests === 1 ? '' : 's'}`;
      return `${guests}${!!showLabel ? label : ''}`
    }
  }

  render() {
    return PlusMinusQuantity(this.getValue, this.onChange)
  }
}

export default connect(mapStateToProps)(GuestsQuantity);
